<template>
  <div id="image_previewer" style="display: none">
    <div class="image-previewer-content">
      <div class="image-previewer-close" onclick="SadvancedPreviewer.hidePreviewImage()">
        <i icon="close circle"></i>
      </div>
      <img id="preview_image" />
    </div>
  </div>
</template>
